import {
    ADD_MODAL_EXPORT,
    ADD_MODAL_HISTORIQUE,
    ADD_MODAL_ADDTOLIST,
    ADD_TO_LIST,
    ADD_CALCUL_RESULTAT,
    ADD_CALCUL_HISTORIQUE,
    ADD_WORK_ID,
    ADD_TO_LIST_CONDITION,
    ADD_LIST,
    ADD_ARTICLE,
    ADD_ATL_ERROR,
    ADD_HOW_TO_LINK,
    ADD_HOW_TO_TEXT,
    ADD_WORK_TITLE,
    ADD_WORK_DESCRIPTION,
    ADD_MODAL_LOADER
} from '../../constants/ConfigFileConstants'

export const addModalExport = modal_export => {
    return {
        type: ADD_MODAL_EXPORT,
        payload: {
            modal_export
        }
    }
}

export const addModalHistorique = modal_historique => {
    return {
        type: ADD_MODAL_HISTORIQUE,
        payload: {
            modal_historique
        }
    }
}

export const addModalAddToList = modal_addToList => {
    return {
        type: ADD_MODAL_ADDTOLIST,
        payload: {
            modal_addToList
        }
    }
}

export const addModalLoader = modal_loader => {
    return {
        type: ADD_MODAL_LOADER,
        payload: {
            modal_loader
        }
    }
}

export const addToList = addToList => {
    return {
        type: ADD_MODAL_ADDTOLIST,
        payload: {
            addToList
        }
    }
}

export const addCalculResult = calculResult => {
    return{
        type: ADD_CALCUL_RESULTAT,
        payload: {
            calculResult
        }
    }
}

export const addCalculHistorique = calculHisto => {
    return{
        type: ADD_CALCUL_HISTORIQUE,
        payload: {
            calculHisto
        }
    }
}

export const addWorkId = workId => {
    return{
        type: ADD_WORK_ID,
        payload: {
            workId
        }
    }
}

export const addToListCondition = addToListCondi => {
    return{
        type: ADD_TO_LIST_CONDITION,
        payload: {
            addToListCondition
        }
    }
}

export const addList = list => {
    return{
        type: ADD_LIST,
        payload: {
            list
        }
    }
}

export const addArticle = article => {
    return{
        type: ADD_ARTICLE,
        payload: {
            article
        }
    }
}

export const addAtlError = atlError => {
    return{
        type: ADD_ATL_ERROR,
        payload: {
            atlError
        }
    }
}

export const addCalculError = calculError => {
    return{
        type: ADD_ATL_ERROR,
        payload: {
            calculError
        }
    }
}

export const addHowToLink = howToLink => {
    return{
        type: ADD_HOW_TO_LINK,
        payload: {
            howToLink
        }
    }
}

export const addHowToText = howToText => {
    return{
        type: ADD_HOW_TO_TEXT,
        payload: {
            howToText
        }
    }
}

export const addWorkTile = workTitle => {
    return{
        type: ADD_WORK_TITLE,
        payload: {
            workTitle
        }
    }
}

export const addWorkDescription = workDescription => {
    return{
        type: ADD_WORK_DESCRIPTION,
        payload: {
            workDescription
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/ConfigFileAction.js